/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-wrap-multilines */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import { linkedAdjustmentsShape } from '../../../../../common/components/proptypes/commonProptypes';
import { getLinksDescriptor } from '../AdjustmentGroup/AdjustmentGroupHelpers';
import { LinkedAdjustmentLinkIcon } from '../LinkedAdjustmentLinkIcon';
import LinkedAdjustmentEditPopover from './LinkedAdjustmentEditPopover';
import './LinkedAdjustmentsEditOverlayTrigger.scss';

const LinkedAdjustmentEditOverlayTrigger = ({
  adjustmentLinks,
  adjustmentOptions,
  targetDocumentOptions,
  selectedLinkedAdjustments,
  sourceAdjustment,
  setFieldValue,
  projectId,
  onToggle,
  show,
  handleKeyDown,
}) => {
  const [selected, setSelected] = useState(false);
  const linksDescriptor = getLinksDescriptor(adjustmentLinks);

  const setValues = (...args) => {
    setSelected(false);
    setFieldValue(...args);
  };

  const selectedAdjustments = (selectedLinkedAdjustments || []).filter(
    (s) => s.sourceAdjustment === sourceAdjustment
  );

  const isInteractive = selectedAdjustments.length > 0;

  return (
    <OverlayTrigger
      rootClose
      trigger="click"
      placement="bottom-end"
      show={show}
      overlay={
        <LinkedAdjustmentEditPopover
          sourceAdjustment={sourceAdjustment}
          adjustmentOptions={adjustmentOptions}
          targetDocumentOptions={targetDocumentOptions}
          selectedLinkedAdjustments={selectedAdjustments}
          setFieldValue={setValues}
          adjustmentLinks={adjustmentLinks}
          projectId={projectId}
          handleKeyDown={handleKeyDown}
        />
      }
      onToggle={onToggle}
    >
      <div
        className="adjustment-link"
        data-testid="adjustment-link"
        onKeyDown={handleKeyDown}
      >
        <LinkedAdjustmentLinkIcon
          isVisible={show}
          isSelected={selected}
          isBroken={linksDescriptor.hasBrokenLinks}
          interactive={isInteractive}
          handleKeyDown={handleKeyDown}
        />
      </div>
    </OverlayTrigger>
  );
};

LinkedAdjustmentEditOverlayTrigger.propTypes = {
  adjustmentLinks: PropTypes.arrayOf(linkedAdjustmentsShape),
};

LinkedAdjustmentEditOverlayTrigger.defaultProps = {
  adjustmentLinks: [],
};

export default LinkedAdjustmentEditOverlayTrigger;
